import { application } from "./application"
import FormFeedbackController from "./form_feedback_controller"
import HelloController from "./hello_controller"

application.register("form-feedback", FormFeedbackController)
application.register("hello", HelloController)
